import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getAvailableLanguages, changeLanguage } from '../../i18n';

/**
 * Composant permettant de changer la langue de l'application
 */
const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'fr');
  const languages = getAvailableLanguages();
  
  // Surveille les changements de langue pour mettre à jour l'état
  useEffect(() => {
    const handleLanguageChanged = (lng) => {
      setCurrentLanguage(lng);
      // Stockage supplémentaire dans localStorage au cas où
      localStorage.setItem('i18nextLng', lng);
    };

    // Abonnement aux changements de langue
    i18n.on('languageChanged', handleLanguageChanged);
    
    // Mise à jour de l'état initial
    setCurrentLanguage(i18n.language.split('-')[0]); // Pour gérer les codes comme "fr-FR"
    
    // Nettoyage
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);

  // Gestionnaire de changement de langue
  const handleLanguageChange = (languageCode) => {
    console.log(`Changing language to: ${languageCode}`);
    changeLanguage(languageCode);
  };

  return (
    <div>
      <p className="font-medium mb-2">{t('settings.app.language')}</p>
      <div className="space-y-2">
        {languages.map((lang) => {
          // Comparer en ignorant les variantes régionales (fr-FR -> fr)
          const isSelected = currentLanguage.startsWith(lang.code);
          
          return (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full flex items-center justify-between p-2 rounded-md ${
                isSelected
                  ? 'bg-blue-50 text-blue-600'
                  : 'hover:bg-gray-50'
              }`}
              aria-pressed={isSelected}
            >
              <div className="flex items-center">
                <span className="text-xl mr-3">{lang.flag}</span>
                <span>{lang.name}</span>
              </div>
              {isSelected && (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
